import React, { useState, useRef, useEffect } from 'react';

const API_URL = '/api/content';

const ServiceCard = ({ service }) => {
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col h-full">
      <div className="h-48 bg-gradient-to-br from-pink-100 to-pink-200 flex items-center justify-center relative overflow-hidden">
        {service.image ? (
          <img src={service.image} alt={service.title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-gray-200 border-2 border-dashed flex items-center justify-center">
            <span className="text-gray-400">No image</span>
          </div>
        )}
      </div>
      
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-xl font-bold text-gray-900 mb-3">
          {service.title}
        </h3>
        <p className="text-gray-600 flex-grow">
          {service.description}
        </p>
      </div>
    </div>
  );
};

const Services = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [services, setServices] = useState([]);
  const containerRef = useRef(null);

  useEffect(() => {
    fetch(`${API_URL}/services`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          setServices(data);
        }
      })
      .catch(err => console.error('Error fetching services:', err));
  }, []);

  useEffect(() => {
    if (services.length === 0) return;
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % services.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [services.length]);

  const getDisplaySlides = () => {
    if (services.length === 0) return [];
    const displaySlides = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentSlide + i) % services.length;
      displaySlides.push(services[index]);
    }
    return displaySlides;
  };

  if (services.length === 0) return null;

  return (
    <section className="py-20 bg-white border-t border-gray-200">
      <div className="container mx-auto px-4 mb-8">
        <div className="text-center">
          <div className="flex items-center justify-center mb-6">
            <div className="flex-1 h-px bg-gray-300"></div>
            <h2 className="text-4xl font-bold text-gray-900 px-8">
              OUR SERVICES
            </h2>
            <div className="flex-1 h-px bg-gray-300"></div>
          </div>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Delivering excellence through innovation and precision
          </p>
        </div>
      </div>

      <div className="py-12">
        <div className="container mx-auto px-4">
          <div className="relative max-w-full mx-auto">
            <div ref={containerRef} className="relative overflow-hidden">
              <div className="flex gap-6 justify-center">
                {getDisplaySlides().map((service, index) => (
                  <div key={`${index}`} className="w-full md:w-1/2 lg:w-[calc(33.333%-16px)] flex-shrink-0 px-2">
                    <ServiceCard service={service} />
                  </div>
                ))}
              </div>

              {/* Dots Navigation */}
              <div className="flex justify-center gap-2 mt-8">
                {services.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`h-3 rounded-full transition-all ${
                      currentSlide === index 
                        ? 'bg-pink-600 w-8' 
                        : 'bg-gray-300 hover:bg-gray-400 w-3'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
